// extracted by mini-css-extract-plugin
module.exports = {"dashboardTitle":"DashboardTitle_dashboardTitle__15uSi","dashboardTitleName":"DashboardTitle_dashboardTitleName__2qtu_"};